import { USER_TYPES, UserTypeValue } from "../types/userType";

export const toRoleArray = (
  value: string | UserTypeValue[] | null
): UserTypeValue[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      return parsed as UserTypeValue[];
    }
  } catch {
    // Ignore JSON parse errors
  }
  if (typeof value === "string" && value.includes(",")) {
    return value
      .split(",")
      .map((role) => role.trim())
      .filter(Boolean) as UserTypeValue[];
  }
  return [value as UserTypeValue];
};

export const getDefaultRoute = (roles: UserTypeValue[]): string => {
  const isAdmin = roles.includes(USER_TYPES.ADMIN);
  const isSuperAdmin = roles.includes(USER_TYPES.SUPER_ADMIN);
  const isInspection = roles.includes(USER_TYPES.INSPECTION);
  const isRental = roles.includes(USER_TYPES.RENTAL);
  const isOperate = roles.includes(USER_TYPES.OPERATE);
  const isFreesbe = roles.includes(USER_TYPES.FREESBE);

  if (
    (isOperate || isFreesbe) &&
    !isInspection &&
    !isRental &&
    !isAdmin &&
    !isSuperAdmin
  ) {
    return "/accident-report-table";
  }
  if (isInspection && !isRental && !isAdmin && !isSuperAdmin) {
    return "/car-inspection-table";
  }
  if (isRental && !isAdmin && !isSuperAdmin) {
    return "/cars";
  }
  return "/users";
};

